(() => {
  'use strict';
  if (window.rsHighscoresLoaded) return;
  window.rsHighscoresLoaded = true;
  const firebaseConfig = {
  apiKey: "AIzaSyBlxw4A6HUp3c3ydA1gxQyNfew3VRMuFo8",
  authDomain: "pixel-jumper-43541.firebaseapp.com",
  projectId: "pixel-jumper-43541",
  storageBucket: "pixel-jumper-43541.firebasestorage.app",
  messagingSenderId: "100679285037",
  appId: "1:100679285037:web:a1ac0a00d1c29d3296fba4"
};
  const sdk = () => {
    if (window.rsScoresSDK) return window.rsScoresSDK;
    window.rsScoresSDK = (async () => {
      for (const part of ['app', 'firestore']) {
        if (window.firebase && (part === 'app' || window.firebase.firestore)) continue;
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = `https://www.gstatic.com/firebasejs/9.22.0/firebase-${part}-compat.js`;
          script.onload = resolve; script.onerror = reject; document.head.append(script);
        });
      }
      const app = firebase.apps.find(app => app.name === 'rs-highscores') || firebase.initializeApp(firebaseConfig, 'rs-highscores');
      return app.firestore();
    })().catch(error => {
      window.rsScoresSDK = null;
      throw error;
    });
    return window.rsScoresSDK;
  };
  function mount(root) {
    if (root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    const de = root.dataset.lang === 'de';
    const status = root.querySelector('[data-score-status]');
    const body = root.querySelector('tbody');
    const search = root.querySelector('[data-score-search]');
    let rows = [], generation = 0;
    let desertMode = null;
    if (root.dataset.game === 'desert' && !root.dataset.endpoint) {
      const label = document.createElement('label');
      label.textContent = de ? 'Spielmodus' : 'Game mode';
      desertMode = document.createElement('select');
      desertMode.setAttribute('aria-label', de ? 'Spielmodus' : 'Game mode');
      for (const mode of ['normal', 'hardcore']) {
        const option = document.createElement('option');
        option.value = mode; option.textContent = mode === 'normal' ? 'Normal' : 'Hardcore';
        desertMode.append(option);
      }
      label.append(desertMode);
      root.querySelector('table').before(label);
    }
    function render() {
      body.replaceChildren();
      const term = search ? search.value.toLocaleLowerCase().trim() : '';
      const shown = rows.filter(row => row.name.toLocaleLowerCase().includes(term));
      shown.forEach(row => {
        const tr = document.createElement('tr');
        [row.rank, row.name, row.score.toLocaleString(de ? 'de-DE' : 'en-US')].forEach(value => {
          const td = document.createElement('td'); td.textContent = String(value); tr.append(td);
        });
        body.append(tr);
      });
      status.textContent = shown.length ? '' : (rows.length ? (de ? 'Keine passenden Namen in dieser Liste.' : 'No matching names in this list.') : (de ? 'Noch keine Punktestände.' : 'No scores yet.'));
    }
    async function load() {
      const id = ++generation;
      rows = []; body.replaceChildren();
      status.textContent = de ? 'Punktestände werden geladen …' : 'Loading scores …';
      const controller = new AbortController();
      const timer = setTimeout(() => { controller.abort(); if (id === generation) { generation++; status.textContent = de ? 'Highscores derzeit nicht verfügbar. Bitte erneut versuchen.' : 'Scores unavailable. Please try again.'; } }, 20000);
      try {
        let entries;
        if (root.dataset.game === 'desert' && root.dataset.endpoint) {
          const endpoint = root.dataset.endpoint;
          const url = new URL(endpoint);
          if (url.protocol !== 'https:' || url.username || url.password) throw Error('Invalid endpoint');
          const response = await fetch(url.href, {signal: controller.signal, credentials: 'omit'});
          if (!response.ok) throw Error('Scores unavailable');
          const payload = await response.json();
          if (!payload || !Array.isArray(payload.scores)) throw Error('Invalid scores');
          entries = payload.scores;
        } else {
          const db = await sdk();
          // Public Desert source uses its own collections in the same Firebase project.
          const collection = root.dataset.game === 'desert'
            ? (desertMode?.value === 'hardcore' ? 'desert_peng_hardcore_scores' : 'desert_peng_normal_scores')
            : 'highscores';
          const period = root.querySelector('[data-score-period]')?.value || 'all';
          const limit = Number(root.dataset.limit) || 10;
          if (period === 'all') {
            const snapshot = await db.collection(collection).orderBy('score', 'desc').limit(limit).get();
            entries = snapshot.docs.map(doc => doc.data());
          } else {
            const start = new Date(); start.setHours(0, 0, 0, 0);
            if (period === 'week') start.setDate(start.getDate() - 6);
            if (period === 'month') start.setDate(start.getDate() - 29);
            const base = db.collection(collection).where('timestamp', '>=', start.getTime()).orderBy('timestamp', 'desc');
            entries = []; let cursor = null;
            // Fetch the complete period before ranking. Never rank a truncated sample.
            for (;;) {
              if (id !== generation) return;
              const snapshot = await (cursor ? base.startAfter(cursor) : base).limit(1000).get();
              entries.push(...snapshot.docs.map(doc => doc.data()));
              if (snapshot.size < 1000) break;
              if (entries.length >= 2000) throw Error('Period too large to rank completely');
              cursor = snapshot.docs[snapshot.docs.length - 1];
            }
          }
        }
        if (id !== generation) return;
        if (!entries.every(row => row && typeof row.name === 'string' && typeof row.score === 'number' && Number.isFinite(row.score) && row.score >= 0)) throw Error('Invalid scores');
        rows = entries.sort((a, b) => b.score - a.score).slice(0, Number(root.dataset.limit) || 10).map((row, i) => ({name: row.name, score: row.score, rank: i + 1}));
        render();
      } catch (_) {
        if (id === generation) status.textContent = de ? 'Highscores derzeit nicht verfügbar. Bitte erneut versuchen.' : 'Scores unavailable. Please try again.';
      } finally { clearTimeout(timer); }
    }
    desertMode?.addEventListener('change', load);
    search?.addEventListener('input', render);
    root.querySelector('[data-score-period]')?.addEventListener('change', load);
    root.querySelector('[data-score-retry]')?.addEventListener('click', load);
    load();
  }
  function init() { document.querySelectorAll('[data-rs-highscores]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
